export class AuthenticationRequires2FAError extends Error {}
